export default {
  data: () => ({
    gRecaptchaToken: null,
  }),
  methods: {
    onVerify(response) {
      this.gRecaptchaToken = response;
    },
    clearRecaptchaToken() {
      this.gRecaptchaToken = null;
    },
  },
};
